import { IconProps } from './icons-props';

function InstagramIcon({ className, width = 20, height = 20 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12.4998 18.9584H7.49984C2.97484 18.9584 1.0415 17.0251 1.0415 12.5001V7.50008C1.0415 2.97508 2.97484 1.04175 7.49984 1.04175H12.4998C17.0248 1.04175 18.9582 2.97508 18.9582 7.50008V12.5001C18.9582 17.0251 17.0248 18.9584 12.4998 18.9584ZM7.49984 2.29175C3.65817 2.29175 2.2915 3.65841 2.2915 7.50008V12.5001C2.2915 16.3417 3.65817 17.7084 7.49984 17.7084H12.4998C16.3415 17.7084 17.7082 16.3417 17.7082 12.5001V7.50008C17.7082 3.65841 16.3415 2.29175 12.4998 2.29175H7.49984Z'
                fill='currentColor'
            />
            <path
                d='M10.0002 13.5416C8.05016 13.5416 6.4585 11.9499 6.4585 9.99992C6.4585 8.04992 8.05016 6.45825 10.0002 6.45825C11.9502 6.45825 13.5418 8.04992 13.5418 9.99992C13.5418 11.9499 11.9502 13.5416 10.0002 13.5416ZM10.0002 7.70825C8.7335 7.70825 7.7085 8.73325 7.7085 9.99992C7.7085 11.2666 8.7335 12.2916 10.0002 12.2916C11.2668 12.2916 12.2918 11.2666 12.2918 9.99992C12.2918 8.73325 11.2668 7.70825 10.0002 7.70825Z'
                fill='currentColor'
            />
            <path
                d='M14.1668 6.24992C14.0585 6.24992 13.9502 6.22492 13.8502 6.18325C13.7502 6.14159 13.6585 6.08325 13.5752 6.00825C13.5002 5.92492 13.4335 5.83325 13.3918 5.73325C13.3502 5.63325 13.3335 5.52492 13.3335 5.41659C13.3335 5.30825 13.3502 5.19992 13.3918 5.09992C13.4418 4.99159 13.5002 4.90825 13.5752 4.82492C13.6168 4.79159 13.6585 4.74992 13.7002 4.72492C13.7502 4.69159 13.8002 4.66659 13.8502 4.64992C13.9002 4.62492 13.9502 4.60825 14.0085 4.59992C14.2752 4.54159 14.5585 4.63325 14.7585 4.82492C14.8335 4.90825 14.8918 4.99159 14.9335 5.09992C14.9752 5.19992 15.0002 5.30825 15.0002 5.41659C15.0002 5.52492 14.9752 5.63325 14.9335 5.73325C14.8918 5.83325 14.8335 5.92492 14.7585 6.00825C14.6752 6.08325 14.5835 6.14159 14.4835 6.18325C14.3835 6.22492 14.2752 6.24992 14.1668 6.24992Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default InstagramIcon;

